(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pg-collector-notice"]) return;
  try {
    
  if (!customElements.get('pg-collector-notice')) {
    customElements.define(
      'pg-collector-notice',
      class PgCollectorNotice extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.key = this.dataset.storageKey || 'pg_aviso_ok';
          if (!this.dialog) return;

          // Bloqueante: no se cierra con Escape, solo con el botón.
          this.dialog.addEventListener('cancel', (event) => event.preventDefault());
          this.querySelector('.pg-notice__accept').addEventListener('click', () => this.accept());

          if (this.dataset.preview === 'true' || !this.isAccepted()) this.open();
        }

        isAccepted() {
          try {
            return window.localStorage.getItem(this.key) === '1';
          } catch (e) {
            return false;
          }
        }

        open() {
          if (this.dialog.open || typeof this.dialog.showModal !== 'function') return;
          this.dialog.showModal();
          document.body.classList.add('overflow-hidden');
        }

        accept() {
          try {
            window.localStorage.setItem(this.key, '1');
          } catch (e) {}
          this.dialog.close();
          document.body.classList.remove('overflow-hidden');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-header"]) return;
  try {
    
  if (!customElements.get('pg-menu-drawer')) {
    customElements.define(
      'pg-menu-drawer',
      class PgMenuDrawer extends HTMLElement {
        connectedCallback() {
          this.details = this.querySelector('details');
          this.summary = this.querySelector('summary');
          this.panel = this.querySelector('.pg-menu-drawer__panel');
          this.summary.setAttribute('aria-expanded', 'false');

          this.details.addEventListener('toggle', () => this.onToggle());
          this.querySelector('.pg-menu-drawer__close').addEventListener('click', () => this.close());
          this.querySelector('.pg-menu-drawer__overlay').addEventListener('click', () => this.close());
          this.panel.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => this.close()));
          this.addEventListener('keyup', (event) => {
            if (event.code === 'Escape' || event.key === 'Escape') this.close();
          });
        }

        onToggle() {
          const open = this.details.open;
          this.summary.setAttribute('aria-expanded', String(open));
          document.body.classList.toggle('overflow-hidden', open);
          if (open && typeof trapFocus === 'function') {
            trapFocus(this.panel, this.panel.querySelector('a'));
          } else if (!open && typeof removeTrapFocus === 'function') {
            removeTrapFocus(this.summary);
          }
        }

        close() {
          if (!this.details.open) return;
          this.details.open = false;
          this.summary.focus();
        }
      }
    );
  }

  if (!customElements.get('pg-header')) {
    customElements.define(
      'pg-header',
      class PgHeader extends HTMLElement {
        connectedCallback() {
          this.onScroll = () => this.classList.toggle('is-scrolled', window.scrollY > 8);
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
        }
      }
    );
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-hero-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pg-hero-video')) {
    customElements.define(
      'pg-hero-video',
      class PgHeroVideo extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video) return;

          this.trim = parseFloat(this.dataset.trim) || 0;
          this.video.muted = true;
          this.video.volume = 0;

          // Recorta el final del bucle (el logo): vuelve a 0 antes de llegar al final.
          this.video.addEventListener('timeupdate', () => {
            const { duration, currentTime } = this.video;
            if (!this.video.muted) this.video.muted = true;
            if (this.trim > 0 && duration && duration > this.trim && currentTime > duration - this.trim) {
              this.video.currentTime = 0;
            }
          });
          this.video.addEventListener('playing', () => this.video.classList.add('is-playing'));

          this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.onMotionChange = () => this.update();
          this.motionQuery.addEventListener('change', this.onMotionChange);
          this.update();
        }

        disconnectedCallback() {
          this.motionQuery?.removeEventListener('change', this.onMotionChange);
        }

        update() {
          if (this.motionQuery.matches) {
            this.video.pause();
            this.video.classList.remove('is-playing');
            return;
          }
          this.video.muted = true;
          const promise = this.video.play();
          if (promise) promise.catch(() => {});
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-main-collection"]) return;
  try {
    
  if (!customElements.get('pg-group-filter')) {
    customElements.define(
      'pg-group-filter',
      class PgGroupFilter extends HTMLElement {
        connectedCallback() {
          this.links = Array.from(this.querySelectorAll('[data-group-link]'));
          this.groups = Array.from(this.parentElement.querySelectorAll('[data-group-id]'));
          this.links.forEach((link) =>
            link.addEventListener('click', (event) => {
              event.preventDefault();
              this.show(link.dataset.groupLink);
            })
          );
        }

        show(id) {
          this.links.forEach((link) => {
            if (link.dataset.groupLink === id) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
          this.groups.forEach((group) => (group.hidden = id !== '' && group.dataset.groupId !== id));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-main-product"]) return;
  try {
    
  if (!customElements.get('pg-gallery')) {
    customElements.define(
      'pg-gallery',
      class PgGallery extends HTMLElement {
        connectedCallback() {
          this.thumbs = Array.from(this.querySelectorAll('.pg-gallery__thumb'));
          this.thumbs.forEach((thumb) =>
            thumb.addEventListener('click', () => this.setActive(thumb.dataset.mediaId))
          );

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              const { data } = event;
              if (!data || data.sectionId !== this.dataset.section) return;
              const mediaId = data.variant?.featured_media?.id;
              if (mediaId) this.setActive(String(mediaId));
            });
          }
        }

        disconnectedCallback() {
          this.unsubscribe?.();
        }

        setActive(mediaId) {
          const slides = this.querySelectorAll('.pg-gallery__slide[data-media-id]');
          const target = this.querySelector(`.pg-gallery__slide[data-media-id="${mediaId}"]`);
          if (!target) return;
          slides.forEach((slide) => {
            const active = slide === target;
            slide.hidden = !active;
            slide.classList.toggle('is-current', active);
            if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
          });
          const lazyImage = target.querySelector('img[loading="lazy"]');
          if (lazyImage) lazyImage.loading = 'eager';
          this.thumbs.forEach((thumb) => {
            if (thumb.dataset.mediaId === String(mediaId)) {
              thumb.setAttribute('aria-current', 'true');
            } else {
              thumb.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-newsletter-popup"]) return;
  try {
    
  if (!customElements.get('pg-newsletter-popup')) {
    customElements.define(
      'pg-newsletter-popup',
      class PgNewsletterPopup extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
          this.days = Number(this.dataset.days || 14);
          this.querySelectorAll('[data-close]').forEach((button) => button.addEventListener('click', () => this.close()));
          this.dialog.addEventListener('cancel', () => this.remember('pg_nl_closed'));
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });

          // Tras enviar el formulario, la página vuelve con el resultado: se enseña sin esperar.
          if (this.querySelector('[data-success]')) {
            this.remember('pg_nl_subscribed');
            this.open();
            return;
          }
          if (this.querySelector('[data-error]')) {
            this.open();
            return;
          }
          if (this.dataset.preview === 'true') {
            this.open();
            return;
          }
          if (this.read('pg_nl_subscribed') || this.recentlyClosed()) return;
          this.timer = setTimeout(() => this.tryOpen(), Number(this.dataset.delay || 12) * 1000);
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
        }

        // Nunca encima de otra ventana (aviso para coleccionistas, cesta, visor de fotos…)
        tryOpen() {
          const busy = document.querySelector('dialog[open]') || document.body.classList.contains('overflow-hidden');
          if (busy) {
            this.timer = setTimeout(() => this.tryOpen(), 4000);
            return;
          }
          this.open();
        }

        open() {
          if (this.dialog.open) return;
          this.dialog.showModal();
        }

        close() {
          if (!this.querySelector('[data-success]')) this.remember('pg_nl_closed');
          this.dialog.close();
        }

        recentlyClosed() {
          const closed = Number(this.read('pg_nl_closed') || 0);
          return closed && Date.now() - closed < this.days * 86400000;
        }

        read(key) {
          try {
            return window.localStorage.getItem(key);
          } catch (e) {
            return null;
          }
        }

        remember(key) {
          try {
            window.localStorage.setItem(key, String(Date.now()));
          } catch (e) {}
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-workshop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pg-process')) {
    customElements.define(
      'pg-process',
      class PgProcess extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('.pg-process__tab'));
          this.slides = Array.from(this.querySelectorAll('.pg-process__slide'));
          this.bars = Array.from(this.querySelectorAll('.pg-process__progress span'));

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.select(Number(tab.dataset.index)));
            tab.addEventListener('keydown', (event) => this.onKey(event));
          });
          document.addEventListener('shopify:block:select', (event) => {
            const index = this.tabs.indexOf(event.target);
            if (index > -1) this.select(index);
          });
        }

        onKey(event) {
          const current = this.tabs.indexOf(event.currentTarget);
          let next = null;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === null) return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        }

        select(index) {
          this.tabs.forEach((tab, i) => tab.setAttribute('aria-expanded', String(i === index)));
          this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
          this.bars.forEach((bar, i) => bar.classList.toggle('is-active', i === index));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
